'use strict';

var React = require('react');

var SvgThumbsDownMajor = function SvgThumbsDownMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.133 3.6 1.334 1a2 2 0 0 0 1.2.4h1.333a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.528a4 4 0 0 0-3.578 2.211l-.185.372a2.563 2.563 0 0 1-2.293 1.417h-.709a1.707 1.707 0 0 1-1.707-1.707v-3.293h-2.74a3 3 0 0 1-2.99-3.25l.5-6a3 3 0 0 1 2.99-2.75h4.573a8 8 0 0 1 4.8 1.6Zm-5.133 13.4v-5h-4.74a1 1 0 0 1-.996-1.083l.5-6a1 1 0 0 1 .996-.917h4.573a6 6 0 0 1 3.6 1.2l1.334 1a4 4 0 0 0 .733.436v6.382a6 6 0 0 0-4.894 3.299l-.186.372a.563.563 0 0 1-.504.311h-.416Z"
  }));
};

exports.SvgThumbsDownMajor = SvgThumbsDownMajor;
